import { createAsyncThunk } from '@reduxjs/toolkit'
import i18n from 'i18next'

import apiClient from 'helpers/clients/apiClient'
import { RootState } from 'store/rootReducer'

import { displaySnackbar } from '../snackbar/snackbarSlice'

import { OpeningHoursThunkReturnType } from './interfaces'

export const fetchOpeningHours = createAsyncThunk<
  OpeningHoursThunkReturnType,
  { productId: number },
  { state: RootState }
>('fetchOpeningHours', async ({ productId }, { dispatch, rejectWithValue }) => {
  try {
    const response = await apiClient.getProductOpeningHours(productId)
    if (!response.success || response.data === undefined) {
      throw new Error('Opening hours not found')
    }
    return { openingHours: response.data }
  } catch (err) {
    console.log('Error on fetchOpeningHours', err)
    dispatch(displaySnackbar({ message: i18n.t('error'), isError: true }))
    return rejectWithValue(err)
  }
})
